// extracted by mini-css-extract-plugin
export default {"NavigationLink":"NavigationLink_NavigationLink__GF4Sc","activeLink":"NavigationLink_activeLink__ZFiEE"};